var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-index-anchor',{attrs:{"index":_vm.indexItem}}),_vm._l((_vm.listClassify),function(item,index){return _c('van-cell',{key:index,attrs:{"title":item.label},on:{"click":function($event){return _vm.changeIndex(item.label, item.value)}}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }